module.exports = __webpack_public_path__ + "static/media/profile.8d79462e.svg";